import { PageBuilderApiActionType } from '../types/types';

export interface BasePageBuilderAction {
    action: PageBuilderApiActionType | string;
    initiator: Initiator;
}

export interface PageBuilderMessageParams {
    baseContext: object;
    handlers: MessageHandler[];
}

export type MessageHandler = (context: object) => void;

export const UNKNOWN_ACTION = 'UNKNOWN';

export enum Initiator {
    PageBuilder = 'PAGE_BUILDER',
    Unknown = 'UNKNOWN',
}
